<div class="container">
    <div class="header">
        <h4 class="title">{{ data.title | translate }}</h4>
        <span class="description">{{ data.description | translate }}</span>
    </div>
    <div class="main-container">
        <div *ngFor="let colorData of data.color">
            <app-system-color-input [data]="colorData" [canEditVessel]="canEditVessel"> </app-system-color-input>
        </div>
    </div>
</div>
